import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    gorgonRuns: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    crowdGroupId: null,
    gorgonRunId: null,
    gorgonResultsets: [],
    gorgonResultsetCount: 0,
    gorgonResultsetPage: 1,
    gorgonResultsetPageSize: 5,
    gorgonResultsetPages: 0,
    gorgonResultsetSortField: 'created_at',
    gorgonResultsetSortOrder: 'asc',
    gorgonResultsetSearch: null,
    gorgonResultsetError: '',
    gorgonResultsetId: null,
    formQuestions: [],
    formQuestionError: null,
    gorgonForms: [],
    gorgonFormCount: 0,
    gorgonFormPage: 1,
    gorgonFormPageSize: 5,
    gorgonFormPages: 0,
    gorgonFormSortField: 'form_num',
    gorgonFormSortOrder: 'asc',
    gorgonFormSearch: null,
    gorgonFormError: '',
    gorgonFormDataType: '',
    gorgonFormId: null,
    gorgonFormQuestions: [],
    gorgonFormQuestionCount: 0,
    gorgonFormQuestionPage: 1,
    gorgonFormQuestionPageSize: 5,
    gorgonFormQuestionPages: 0,
    gorgonFormQuestionSortField: 'sort_num',
    gorgonFormQuestionSortOrder: 'asc',
    gorgonFormQuestionSearch: null,
    gorgonFormQuestionError: '',
    gorgonFormQuestionDataType: ''
}

const receivedGorgonRunsData=(state, action)=>{
    const { gorgonRuns,count,page,pageSize,pages,sortField,sortOrder,search,crowdGroupId } = action.data;
    return {
        ...state,
        gorgonRuns: gorgonRuns,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        crowdGroupId: crowdGroupId
    }
}

const receivedGorgonRunsDataError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedGorgonResultsetsData=(state, action)=>{
    const { gorgonResultsets,gorgonRunId,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        gorgonRunId: gorgonRunId,
        gorgonResultsets: gorgonResultsets,
        gorgonResultsetCount: count,
        gorgonResultsetPage: page,
        gorgonResultsetPageSize: pageSize,
        gorgonResultsetPages: pages,
        gorgonResultsetSortField: sortField,
        gorgonResultsetSortOrder: sortOrder,
        gorgonResultsetSearch: search
    }
}

const receivedGorgonResultsetsDataError=(state, action)=> {
    return {
        ...state,
        gorgonResultsetError: action.error
    }
}

const receivedGorgonFormQuestions=(state,action)=>{
    return {
        ...state,
        formQuestions: action.data
    }
}

const receivedAnErrorWhenGetGorgonFormQuestions=(state,action)=>{
    return {
        ...state,
        formQuestionError: action.error
    }
}

const receivedGorgonFormsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        gorgonForms: results,
        gorgonFormCount: count,
        gorgonFormPage: page,
        gorgonFormPageSize: pageSize,
        gorgonFormPages: pages,
        gorgonFormSortField: sortField,
        gorgonFormSortOrder: sortOrder,
        gorgonFormSearch: search,
        gorgonFormDataType: action.dataType
    }
}

const receivedGorgonFormsDataError=(state, action)=> {
    return {
        ...state,
        gorgonFormError: action.error
    }
}

const receivedAdminGorgonFormQuestionsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search,isProd } = action.data;
    return {
        ...state,
        gorgonFormQuestions: results,
        gorgonFormId: action.gorgonFormId,
        gorgonFormQuestionCount: count,
        gorgonFormQuestionPage: page,
        gorgonFormQuestionPageSize: pageSize,
        gorgonFormQuestionPages: pages,
        gorgonFormQuestionSortField: sortField,
        gorgonFormQuestionSortOrder: sortOrder,
        gorgonFormQuestionSearch: search,
        gorgonFormQuestionDataType: action.dataType
    }
}

const receivedAdminGorgonFormQuestionsDataError=(state, action)=> {
    return {
        ...state,
        gorgonFormQuestionError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_GORGON_RUN_DATA]: receivedGorgonRunsData,
    [actionTypes.GET_GORGON_RUN_DATA_ERROR]: receivedGorgonRunsDataError,
    [actionTypes.GET_GORGON_RESULTSET_DATA]: receivedGorgonResultsetsData,
    [actionTypes.GET_GORGON_RESULTSET_DATA_ERROR]: receivedGorgonResultsetsDataError,
    [actionTypes.GET_GORGON_FORM_QUESTIONS_DATA]: receivedGorgonFormQuestions,
    [actionTypes.GET_GORGON_FORM_QUESTIONS_DATA_ERROR]: receivedAnErrorWhenGetGorgonFormQuestions,
    [actionTypes.GET_ADM_GORGON_FORMS_DATA]: receivedGorgonFormsData,
    [actionTypes.GET_ADM_GORGON_FORMS_DATA_ERROR]: receivedGorgonFormsDataError,
    [actionTypes.GET_ADM_GORGON_FORM_QUESTIONS_DATA]: receivedAdminGorgonFormQuestionsData,
    [actionTypes.GET_ADM_GORGON_FORM_QUESTIONS_DATA_ERROR]: receivedAdminGorgonFormQuestionsDataError
});


// WEBPACK FOOTER //
// ./src/redux/gorgon/reducer.js